import { TextTip } from '@@/Tip/TextTip';

export function TimeTip() {
  return (
    <TextTip color="blue">
      Time should be set according to the chosen environments&apos; timezone.
    </TextTip>
  );
}
